import { Card, CardHeader, CardContent } from "@/components/ui/card";
import PlayerCard from './PlayerCard';
import { RosterSectionProps } from './types';

const RosterSection = ({
  title,
  players,
  status,
  onOfferSpot,
  onRescindOffer,
  onAcceptOffer,
  onDeclineOffer,
  onRemoveFromRoster,
  onRemovePlayer,
  onOpenNotes,
  playersWithNotes
}: RosterSectionProps) => {
  const count = players.length;
  const emptyMessages: Record<RosterSectionProps['status'], string> = {
    considering: "No players under consideration. Use 'Player Search' to add players.",
    offered: "No players have been offered spots yet.",
    rostered: "No players have accepted offers for the final roster yet.",
    declined: "No players have declined offers.",
  };

  return (
    <Card className="shadow-none border border-gray-200">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <span className="font-semibold text-lg flex items-center gap-2">
          {title}
          <span className="inline-block bg-gray-200 text-gray-700 text-xs px-2 rounded-full font-medium">{count}</span>
        </span>
      </CardHeader>
      <CardContent className="pt-0">
        {count > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {players.map(tp => (
              <PlayerCard
                key={tp.id}
                teamPlayer={tp}
                status={status}
                onOfferSpot={onOfferSpot}
                onRescindOffer={onRescindOffer}
                onAcceptOffer={onAcceptOffer}
                onDeclineOffer={onDeclineOffer}
                onRemoveFromRoster={onRemoveFromRoster}
                onRemovePlayer={onRemovePlayer}
                onOpenNotes={onOpenNotes}
                hasNotes={playersWithNotes[tp.player_id] || false}
                compact
              />
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-4">{emptyMessages[status]}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default RosterSection;